var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _line, _text6, _g, _text7, _g2, _text8, _g3, _text9, _g4, _text10, _g5, _line2, _g6, _g7, _g8, _g9, _g10, _text11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase2Fig4LedgerEntryAnatomy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 740",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 740,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Anatomy of a ledger entry")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "D-022 as it appears in DECISIONS.md, excerpted. Every entry carries the same fields.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 100,
    width: 760,
    height: 596,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 140,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 17,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-022")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 140,
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Auto-apply prod schema + catalog on deploy")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 162,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#6B7F74"
  }, "Date: 2026-07-09")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 178,
    x2: 780,
    y2: 178,
    stroke: "#E2E8E4"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 206,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "STATUS")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 226
  }, "Decided (founder-directed); probe waived by the founder."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 243
  }, "Supersedes the human-sync control of D-021. Closes #273."))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 277,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CONTEXT")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 297
  }, "Incident #273: merge-to-main auto-deploys, but prod schema"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 314
  }, "pushes were founder-gated, so a column shipped in code before"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 331
  }, "it existed in the database, 500ing catalog pages for ~15 min."))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 365,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "DECISION")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 385
  }, "On every production deploy, schema and full catalog auto-apply"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 402
  }, "in schema-first order from inside the build, before new code"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 419
  }, "serves. No production database URL: the build fails closed."))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 453,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "RISKS (NAMED, FOUNDER-ACCEPTED)")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 473
  }, "(1) a force push auto-approves data-loss statements: follow-up"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 490
  }, "filed to move the deploy path to migrations. (2) money/legal"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 507
  }, "rows ship without a human, accepted under the soft launch."))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 541,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "REVERSIBILITY")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 561
  }, "HIGH. Revert one build command to restore the manual posture."), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 578
  }, "Reversal triggers: a destructive push loses production data;"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 595
  }, "auto-sync repeatedly ships wrong money or legal rows."))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 618,
    x2: 780,
    y2: 618,
    stroke: "#E2E8E4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#6B7F74"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 644
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    textDecoration: "line-through"
  }, "D-021 human-gated production sync"), /*#__PURE__*/React.createElement("tspan", {
    dx: 10,
    fill: "#4A5F56"
  }, "superseded by this entry, kept in the ledger")), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 668
  }, "Full provenance on disk: v1 doc, six lens files, synthesis, v2 doc, this entry."))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 188,
    width: 302,
    height: 70,
    rx: 10,
    fill: "#F7F5FB",
    stroke: "#7C3AED",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 214,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "Overrides stay legible"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 233,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "A waived probe is recorded as waived,"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 248,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "never silently skipped."), /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 224,
    x2: 846,
    y2: 224,
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 284,
    width: 302,
    height: 70,
    rx: 10,
    fill: "#F7F5FB",
    stroke: "#7C3AED",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 310,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "Evidence, not narrative"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 329,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "The incident that forced the decision is"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 344,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "cited by number, with its cost."), /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 314,
    x2: 846,
    y2: 314,
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 440,
    width: 302,
    height: 70,
    rx: 10,
    fill: "#F7F5FB",
    stroke: "#7C3AED",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 466,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "Risks pre-registered"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 485,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "Named at lock time with their follow-ups."), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 500,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "Risk 1 shipped as #277 within a day."), /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 474,
    x2: 846,
    y2: 474,
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 850,
    y: 536,
    width: 302,
    height: 70,
    rx: 10,
    fill: "#F7F5FB",
    stroke: "#7C3AED",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 562,
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "Reversal written at lock"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 581,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "The conditions that would undo the"), /*#__PURE__*/React.createElement("text", {
    x: 870,
    y: 596,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "decision are part of the decision."), /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 570,
    x2: 846,
    y2: 570,
    stroke: "#7C3AED",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 726,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "The entry that superseded a one-day-old lock, written by the same machinery that locked it.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase2Fig4LedgerEntryAnatomy);
export default __webpack_public_path__ + "static/media/case2-fig4-ledger-entry-anatomy.dfda3f74926269a0dc68193baea077dd.svg";
export { ForwardRef as ReactComponent };